let timer = null;
let docEl = document.documentElement;
function setRem() {
  const dpr = window.devicePixelRatio;
  if (dpr > 1.5) {
    var width = docEl.getBoundingClientRect().width;
    var rem = width / 36;
    docEl.style.fontSize = rem + "px";
  } else {
    docEl.style.fontSize = "54px";
  }
}

setRem();

window.addEventListener(
  "resize",
  function() {
    clearTimeout(timer);
    timer = setTimeout(setRem, 300);
  },
  false
);
window.addEventListener(
  "pageshow",
  function(e) {
    if (e.persisted) {
      clearTimeout(timer);
      timer = setTimeout(setRem, 300);
    }
  },
  false
);
